<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Detail Penilaian" @back="back">
            <a-descriptions bordered>
                <a-descriptions-item label="Materi Pelatihan">
                    <div v-if="itemsSession != null">
                        {{ itemsSession.material.name }}
                    </div>
                </a-descriptions-item>
                <a-descriptions-item label="Inspirator">
                    <template v-if="itemsSession != null">
                        {{ itemsSession.inspirator.name }}
                    </template>
                </a-descriptions-item>
                <a-descriptions-item label="Status">
                    <div v-if="classicalVerifyLevel > 1">
                        <a-row type="flex" :gutter="[8,8]">
                            <a-col flex="1 1 200px">
                                <a-tag
                                        :color="colorLevel">
                                    Validasi Level {{ roleLevel(classicalVerifyLevel) }}
                                </a-tag>
                            </a-col>
                            <a-col flex="0 1 300px">
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    v-if="classicalVerifyLevel == classicalRoleLevel"
                                    @click="showConfirm"
                                >Validasi</a-button>
                            </a-col>
                        </a-row>
                    </div>
                    <div v-else>
                        <a-row type="flex" :gutter="[8,8]" v-if="!loading && items.users_scores.length > 0">
                            <a-col flex="1 1 200px">
                                <a-tag color="red">
                                    belum divalidasi
                                </a-tag>
                            </a-col>
                            <a-col flex="0 1 300px">
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    @click="showConfirm"
                                    >Validasi</a-button
                                >
                            </a-col>
                        </a-row>
                    </div>
                </a-descriptions-item>
            </a-descriptions>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.users_scores"
                rowKey="hash"
                :loading="loading"
                :pagination="false"
                bordered>

                <a-table-column key="photo" title="Foto" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div style="text-align: center">
                            <img :src="record.photo" v-if="record.photo != null" width="70px" />
                            <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <a-table-column key="gender" title="Gender" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ gender(record.gender) }}
                    </template>
                </a-table-column>

                <a-table-column key="attachment" title="File Resume" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.activities[0].resumes != null && record.activities[0].resumes.length > 0">
                            <a-button type="link" icon="file-word" size="small" @click="download(record.activities[0].resumes[0].attachment)">
                                Download
                            </a-button>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="uploaded_time" title="Tanggal Upload" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <template v-if="record.activities[0].resumes != null && record.activities[0].resumes.length > 0">
                            {{ moment(record.activities[0].resumes[0].upload_time).format('DD-MM-YYYY HH:mm:ss') }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column-group class="column-score" v-if="classicalRoleLevel == 1">
                    <span slot="title" v-if="classicalRoleLevel == 1">Nilai Raw</span>

                    <a-table-column key="raw_resume" title="Resume" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <div v-if="record.activities[0].resume_score != null">
                                {{ record.activities[0].resume_score.raw_score }}
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="raw_exam" title="Ujian" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <div v-if="record.activities[0].exam_score != null">
                                {{ record.activities[0].exam_score.raw_score }}
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="raw_remidi" title="Remedi" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <div v-if="record.activities[0].remid_score != null">
                                {{ record.activities[0].remid_score.raw_score }}
                            </div>
                        </template>
                    </a-table-column>
                </a-table-column-group>

                <a-table-column-group class="column-score">
                    <span slot="title">Nilai Akhir</span>

                    <a-table-column key="final_resume" title="Resume" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <div v-if="record.activities[0].resume_score != null">
                                {{ record.activities[0].resume_score.score }}
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="final_exam" title="Ujian" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <div v-if="record.activities[0].exam_score != null">
                                {{ record.activities[0].exam_score.score }}
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="final_remidi" title="Remedi" className="align-center text-small text-center"
                    v-if="classicalRoleLevel == 1">
                        <template slot-scope="record">
                            <div v-if="record.activities[0].remid_score != null">
                                {{ record.activities[0].remid_score.score }}
                            </div>
                        </template>
                    </a-table-column>
                </a-table-column-group>

                <a-table-column key="total_score" title="Total" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.activities[0].material_score != null">
                            {{ record.activities[0].material_score.raw_score }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="status" title="Status" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.activities[0].material_score != null">
                            <a-tag :color="record.activities[0].material_score.wom.hex">
                                ({{ record.activities[0].material_score.wom.rating }}) {{ record.activities[0].material_score.graduation_status }}
                            </a-tag>
                        </div>
                    </template>
                </a-table-column>
                
            </a-table>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        class_id: {
            type: String,
            required: true
        },
        session: {
            type: String,
            required: true
        },
        previous: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            processing: false,
            items: {
                users_scores: []
            },
            filters: {
                q: null,
                email: null,
                page: 1
            }
        };
    },
    created() {
        this.filters = _.merge(this.filters, this.$laravel.request);
        this.getItems();
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        itemsSession() {
            return this.items.session != null ? this.items.session : null
        },
        training_module() {
            return this.$laravel.training_modules.classical
        },
        tableColumns() {
            return this.columns
        },
        classicalVerifyLevel(){
            return this.itemsSession != null ? this.itemsSession.classical_verification_level.toString() : ""
        },
        classicalRoleLevel(){
            let role = this.$laravel.roles[this.activeModule.module.identifier]

            let level = 0

            switch(role){
                case "project-owner":
                    level = "1"
                    break
                case "project-manager-client":
                    level = "2"
                    break
                case "project-owner-client":
                    level = "3"
                    break
            }

            return level
        },
        colorLevel(){
            if(this.classicalVerifyLevel >= 4)
                return 'green'

            return 'orange'
        },
    },
    methods: {
        handleSubmit(e) {
           e.preventDefault(e);

            this.processing = true;

            let promise;

            if(this.classicalVerifyLevel == ""){
                this.processing = false;
                return
            }

            promise = this.$http.put(
                this.routeUri("api.classical-scores-verifications.verify", {
                    session: this.session
                }),
                {
                    level: parseInt(this.classicalVerifyLevel)+1
                }
            );

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleReset(e) {
            e.preventDefault();
            this.filters = {
                q: null,
                page: 1
            };
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current;
            this.pushState(this.filters);
            this.getItems();
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical-scores-verifications", {session: this.session}))
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.getItems();
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        download(url) {
            window.open(url, '_blank')
        },
        showConfirm(e) {
            var msg = 'Apakah Anda yakin untuk melanjutkan proses validasi?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.handleSubmit(e)
                },
                onCancel() {},
                class: 'test',
            });
        },
        back() {
            window.location.href = this.routeUri(this.previous)
        },
        roleLevel(level){
            switch (level) {
                case "2":
                    return "2 - PO BK"
                case "3":
                    return "3 - PM Client"
                case "4":
                    return "4 - PO Client"
                default:
                    if(level > 4)
                        return "4 - PO Client"
                    return ""
            }
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        }
    },
}
</script>